import * as React from 'react';
import {
  VtxButton,
  VtxIcon,
  VtxInput,
  VtxModal,
} from '@vertexinc/vtx-ui-react-component-library';
import Logging from '../Logging/Logging';
import RejectionUrlModalProps from './RejectionUrlModalProps.interface';
import './rejection-url-modal.scss';

const bodyStyle = {
  backgroundColor: 'white',
};

const RejectionUrlModal = ({
  isOpen,
  url,
  onOK,
}: RejectionUrlModalProps): JSX.Element => {
  const onCopyUrl = () => {
    const copyText: HTMLInputElement = document.getElementById('url') as HTMLInputElement;

    if (copyText) {
      copyText.select();
      copyText.setSelectionRange(0, 99999); // For mobile devices

      // Copy the text inside the text field
      document.execCommand('copy');
    }
  };

  const Spacer = () => <span style={{ marginRight: '10px' }} />;

  return (
    <div>
      <VtxModal
        visible={isOpen}
        onCancel={(): void => onOK()}
        width="900px"
        bodyStyle={bodyStyle}
        footer={null}
        closable={false}
      >
        <div className="rejectionUrlContainer">
          <div className="rejectionUrlHeading">
            Below is your rejection URL
          </div>
          <div className="rejectionUrlMessage">
            COPY AND PASTE THE URL INTO YOUR BROWSER TO EDIT THE CERTIFICATE
          </div>
          <div className="rejectionUrlUrl">
            <VtxInput
              type="text"
              id="url"
              name="url"
              value={url}
            />
            <Spacer />
            <VtxButton
              id="copyButton"
              icon={<VtxIcon type="copy" fontSize={20} />}
              onClick={onCopyUrl}
              type="link"
            />
          </div>
          <div className="rejectionUrlGrayLine" />
          <div className="rejectionUrlButtons">
            <div className="buttonItemBase">
              <VtxButton
                id="okButton"
                onClick={onOK}
                type="primary"
              >
                RETURN TO QUEUE
              </VtxButton>
            </div>
          </div>
        </div>
      </VtxModal>
    </div>
  );
};

export default RejectionUrlModal;
